import { useNavigate } from "react-router-dom";
import { Typography } from "@mui/material";
import { LayoutUnauthenticated } from "../../components/LayoutUnauthenticated";
import LoadingButton from "../../components/ui/LoadingButton";
import { useIntl } from "../../contexts/IntlContext";

interface NotFoundProps {
  reason?: "not-found" | "forbidden";
}

export function NotFound({ reason = "not-found" }: NotFoundProps) {
  const navigate = useNavigate();
  const intl = useIntl();

  return (
    <LayoutUnauthenticated title={intl.formatMessage({ id: "notFound.oops" })}>
      <Typography
        variant="h5"
        sx={{
          wordWrap: "break-word",
          whiteSpace: "normal",
          textAlign: "center",
        }}
      >
        {intl.formatMessage({ id: reason === "forbidden" ? "notFound.forbidden" : "notFound.pageNotFound" })}
      </Typography>

      <LoadingButton color="primary" onClick={() => navigate("/")} sx={{ width: "100%", mt: 4 }}>
        {intl.formatMessage({ id: "notFound.backToHome" })}
      </LoadingButton>
    </LayoutUnauthenticated>
  );
}
